import { useActiveCircleId } from '../use-active-circle';
import { usePrograms } from '../use-programs';

export function useProgram(programId: string | undefined, _circleId?: number) {
    const { activeCircleId } = useActiveCircleId();
    const circleId = _circleId || activeCircleId;
    const { programs, ...otherProps } = usePrograms(
        programId ? [programId] : [],
        circleId
    );
    return {
        program: programs?.[0],
        ...otherProps,
    };
}
